// tslint:disable
/**
 * TC API
 * TestCollab is a test management tool that helps development teams carry out testing effectively and avoid failures. # Introduction This is an API documentation for TestCollab 2.   # Authentication TestCollab supports two forms of authentication:   - An <b>API token</b> is required to make API calls. The token can be generated from user's profile; to obtain it login to your TestCollab account and go to ['My Profile Settings'](https://testcollab.io/my_profile) and switch to API Token tab. Click on \"Generate new API token\", Once the token is generated it can be sent as a query parameter for the API calls made - https://api.testcollab.io/projects?token=<generated-API-token>    - <b>Bearer authentication</b> (also called token authentication) is an HTTP authentication scheme that involves security tokens called bearer tokens. You can generate bearer auth token using [Login](#operation/login) API.     Send this token as the Authorization header while making requests to protected resources:     `Authorization: Bearer <token>`    For making API calls, we recommend using the <b>API token</b> generated from user profile page as it won't affect the on-going user session and will be available until it is revoked by the user who generated it.      # Error Handling Error responses   - `Not Found` - Error is sent when requested resource is not available.   - `Unauthorized - invalid token` - Error is sent when API token sent with the request is invalid or revoked. Error contains status code 401        - `Forbidden` - Error is sent when logged in user is not part of the company, project or his role does not allow to complete given action. Response consist of 403 status code and more information is given in error message.
 *
 * OpenAPI spec version: 2.3.1
 * Contact: support@testcollab.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from "../runtime";
import {
  BuildTestPlanResultResults,
  BuildTestPlanResultResultsFromJSON,
  BuildTestPlanResultResultsToJSON,
} from "./";

/**
 * A test plan linked to a build, with its cached result distribution (TCV-6726).
 * @export
 * @interface BuildTestPlanResult
 */
export interface BuildTestPlanResult {
  /**
   *
   * @type {number}
   * @memberof BuildTestPlanResult
   */
  id: number;
  /**
   * Per-company business number of the plan (rendered as TP-<n>).
   * @type {number}
   * @memberof BuildTestPlanResult
   */
  displayNumber?: number;
  /**
   *
   * @type {string}
   * @memberof BuildTestPlanResult
   */
  title: string;
  /**
   * Test plan execution status — 0 not started, 1 in progress, 2 completed, 3 on hold, 4 aborted.
   * @type {string}
   * @memberof BuildTestPlanResult
   */
  status?: string;
  /**
   * Number of test cases in the plan.
   * @type {number}
   * @memberof BuildTestPlanResult
   */
  totalCases?: number;
  /**
   * When this plan last recorded a result against this build (TCV-6828). Null until something is executed — a plan that is linked but has never run carries no date, rather than the date its run was created. Always null for a `linked_only` plan (TCV-6827): any execution it has belongs to another build.
   * @type {string}
   * @memberof BuildTestPlanResult
   */
  lastRun?: string;
  /**
   * TCV-6827. True when the plan is linked to this build but no test run was recorded against it — typically a plan that was executed before it was linked, whose results stay attributed to the build they actually ran against. Such a plan has no results and no `last_run` here.
   * @type {boolean}
   * @memberof BuildTestPlanResult
   */
  linkedOnly?: boolean;
  /**
   *
   * @type {BuildTestPlanResultResults}
   * @memberof BuildTestPlanResult
   */
  results?: BuildTestPlanResultResults;
}

export function BuildTestPlanResultFromJSON(json: any): BuildTestPlanResult {
  return {
    id: json["id"],
    displayNumber: !exists(json, "display_number")
      ? undefined
      : json["display_number"],
    title: json["title"],
    status: !exists(json, "status") ? undefined : json["status"],
    totalCases: !exists(json, "total_cases") ? undefined : json["total_cases"],
    lastRun: !exists(json, "last_run") ? undefined : json["last_run"],
    linkedOnly: !exists(json, "linked_only") ? undefined : json["linked_only"],
    results: !exists(json, "results")
      ? undefined
      : BuildTestPlanResultResultsFromJSON(json["results"]),
  };
}

export function BuildTestPlanResultToJSON(value?: BuildTestPlanResult): any {
  if (value === undefined) {
    return undefined;
  }
  return {
    id: value.id,
    display_number: value.displayNumber,
    title: value.title,
    status: value.status,
    total_cases: value.totalCases,
    last_run: value.lastRun,
    linked_only: value.linkedOnly,
    results: BuildTestPlanResultResultsToJSON(value.results),
  };
}
